if ( $('section#partners-signup').length ) {
  $(function(){
    $('#submit').on('click', function(){
      $('#partners-form').submit();
    })
  });
}
